/**
 * Green wave background — extends behind safe area via negative top
 * so green fills from the very top of the screen.
 * Scrolls with the page, so it disappears naturally when content moves up.
 */
export function GreenWave() {
  return (
    <div
      className="absolute left-0 w-full bg-primary z-0 pointer-events-none"
      style={{
        top: 'calc(-1 * (var(--tg-content-safe-area-inset-top, 0px) + 26px))',
        height: 'calc(200px + var(--tg-content-safe-area-inset-top, 0px) + 26px)',
      }}
    >
      <svg
        className="absolute bottom-0 left-0 w-full h-[112px]"
        viewBox="0 0 428 112"
        preserveAspectRatio="none"
      >
        <rect width="428" height="112" fill="hsl(var(--background))" />
        <path
          d="M0 0L428 0 428 70C428 70 393 57.972 313 61 233 64.028 207 111 113.5 111 20 111 0 70 0 70Z"
          fill="hsl(var(--primary))"
        />
      </svg>
    </div>
  );
}
